import { createFeatureSelector, createSelector } from "@ngrx/store";
import { LedgerState } from "./ledger.reducer";

export const selectLedgerState = createFeatureSelector<LedgerState>('ledgers');

// All ledgers for a company and year
export const selectAllLedgers = (companyId: number, financialYear: string) => createSelector(
    selectLedgerState,
    state => state.ledgers.filter(
        ledger => ledger.companyID == companyId && ledger.financialYear == financialYear
    )
);

// Parties (Cash, Debtors, Creditors, Bank) for a company and year
export const selectAllParties = (companyId: number, financialYear: string) => createSelector(
    selectLedgerState,
    state => state.ledgers.filter(
        ledger =>
            (
                ledger.parentLevel == 'Cash Account' ||
                ledger.parentLevel == 'Sundry Debtors' ||
                ledger.parentLevel == 'Sundry Creditors' ||
                ledger.parentLevel == 'Bank Accounts'
            ) &&
            ledger.companyID == companyId &&
            ledger.financialYear == financialYear
    )
);

// Sales ledgers (excluding Bank and Cash) for a company and year
export const selectAllSalesLedgers = (companyId: number, financialYear: string) => createSelector(
    selectLedgerState,
    state => state.ledgers.filter(
        ledger =>
            ledger.parentLevel !== 'Bank Accounts' &&
            ledger.parentLevel !== 'Cash Account' &&
            ledger.companyID == companyId &&
            ledger.financialYear == financialYear
    )
);